import React from 'react';
import Grid from '@material-ui/core/Grid';
import i18next from 'i18next';

import { useSelector } from 'react-redux';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import Accordion from '~/components/Accordion';
import { MultiSelect } from '~/components/Select';
import AddMore from '~/components/Button/AddButton';
import { useFormikContext } from 'formik';
import ProcessCard from '~/components/ProcessCard';

import { Container, Divider, WrapperMulti } from './styles';

const OperationalReturnProcess = () => {
  const { peopleEnum } = useSelector((state) => state.people);
  const {
    values,
    //  handleChange, touched, errors, handleBlur,
    setFieldValue,
  } = useFormikContext();

  const addNew = () => {
    const newProcess = [
      ...values.pcn?.operationalResponse.processes,
      { description: '', asset_id: '', document_id: '' },
    ];

    setFieldValue('pcn.operationalResponse.processes', newProcess);
  };

  const updateProcess = (index, updated) => {
    const newProcesses = values.pcn.operationalResponse.processes;
    newProcesses[index] = { ...newProcesses[index], ...updated };

    setFieldValue('pcn.operationalResponse.processes', newProcesses);
  };

  const moveCardHandler = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    if (destination.index === source.index) {
      return;
    }

    const dragItem = values.pcn.operationalResponse.processes[source.index];
    const newProcesses = [...values.pcn.operationalResponse.processes];
    newProcesses.splice(source.index, 1);
    newProcesses.splice(destination.index, 0, dragItem);
    setFieldValue('pcn.operationalResponse.processes', newProcesses);
  };

  const removeItem = (pcnIndex) => {
    const result = values.pcn?.operationalResponse.processes;
    result.splice(pcnIndex, 1);
    setFieldValue('pcn.operationalResponse.processes', result);
  };

  return (
    <Accordion
      title={i18next.t('technologiesAsset.tabs.pcn.operationalResponse.title')}
    >
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <WrapperMulti>
            <MultiSelect
              label={i18next.t(
                'technologiesAsset.tabs.pcn.operationalResponse.responsiblesOperationalResponse'
              )}
              oneLineLabel={false}
              options={peopleEnum}
              onChange={(e) =>
                setFieldValue('pcn.operationalResponse.return', e)
              }
              value={values.pcn.operationalResponse.return}
            />
          </WrapperMulti>
        </Grid>
        <Grid item xs={4}>
          <WrapperMulti>
            <MultiSelect
              label={i18next.t(
                'technologiesAsset.tabs.pcn.operationalResponse.responsiblesTestOperationalResponse'
              )}
              oneLineLabel={false}
              options={peopleEnum}
              onChange={(e) =>
                setFieldValue('pcn.operationalResponse.tests', e)
              }
              value={values.pcn.operationalResponse.tests}
            />
          </WrapperMulti>
        </Grid>
        <Grid item xs={4}>
          <WrapperMulti>
            <MultiSelect
              label={i18next.t(
                'technologiesAsset.tabs.pcn.operationalResponse.reponsiblesComunicationOperationalResponse'
              )}
              oneLineLabel={false}
              options={peopleEnum}
              onChange={(e) =>
                setFieldValue('pcn.operationalResponse.communication', e)
              }
              value={values.pcn.operationalResponse.communication}
            />
          </WrapperMulti>
        </Grid>
      </Grid>
      <Divider />
      <DragDropContext onDragEnd={moveCardHandler}>
        <Droppable droppableId="Processo de retorno operacional">
          {(provided) => (
            <Container
              ref={provided.innerRef}
              {...provided.droppableProps}
              container
              spacing={4}
              style={{ marginBottom: '10rem' }}
            >
              {values.pcn.operationalResponse.processes.map(
                (process, index) => (
                  <ProcessCard
                    index={index}
                    process={process}
                    onRemove={removeItem}
                    updateProcess={updateProcess}
                    moveCardHandler={moveCardHandler}
                  />
                )
              )}
              {provided.placeholder}
              <Grid item xs={12} style={{ marginTop: '2rem' }}>
                <AddMore onClick={addNew} />
              </Grid>
            </Container>
          )}
        </Droppable>
      </DragDropContext>
    </Accordion>
  );
};

export default OperationalReturnProcess;
